import api from "../api";
import qs from "qs";

const serialize = (params) => qs.stringify(params, { arrayFormat: "repeat" });

export const mensagemGlobalService = {
  listarAdmin(params) {
    return api.get("/admin/mensagens-globais", {
      params,
      paramsSerializer: serialize,
    });
  },
  buscarAdmin(codigo) {
    return api.get(`/admin/mensagens-globais/${codigo}`);
  },
  listarGrupos() {
    return api.get("/admin/mensagens-globais/grupos");
  },
  listarLeituras(codigo, params) {
    return api.get(`/admin/mensagens-globais/${codigo}/leituras`, {
      params,
      paramsSerializer: serialize,
    });
  },
  criar(payload) {
    return api.post("/admin/mensagens-globais", payload);
  },
  listarNaoLidas() {
    return api.get("/mensagens-globais/nao-lidas");
  },
  contarNaoLidas() {
    return api.get("/mensagens-globais/nao-lidas/contador");
  },
  marcarComoLida(codigo) {
    return api.put(`/mensagens-globais/${codigo}/lida`);
  },
};
